"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWith = exports.STARTS_WITH = exports.includes = exports.IN = exports.isEmpty = exports.IS_EMPTY = exports.endsWith = exports.ENDS_WITH = exports.contains = exports.CONTAINS = void 0;
var tslib_1 = require("tslib");
var mathjs_1 = require("mathjs");
var endsWith_1 = tslib_1.__importDefault(require("ramda/src/endsWith"));
var includes_1 = tslib_1.__importDefault(require("ramda/src/includes"));
var isEmpty_1 = tslib_1.__importDefault(require("ramda/src/isEmpty"));
var isNil_1 = tslib_1.__importDefault(require("ramda/src/isNil"));
var startsWith_1 = tslib_1.__importDefault(require("ramda/src/startsWith"));
var type_1 = tslib_1.__importDefault(require("ramda/src/type"));
var ramdaFactory = function (key, fn) {
    return mathjs_1.factory(key, [], function () { return fn; });
};
var Contains = function (a, b) { return includes_1.default(b, a); };
exports.CONTAINS = ramdaFactory('CONTAINS', Contains);
exports.contains = ramdaFactory('contains', Contains);
var legacyEndsWith = function (a, b) { return endsWith_1.default(b, a); };
exports.ENDS_WITH = ramdaFactory('ENDS_WITH', legacyEndsWith);
exports.endsWith = ramdaFactory('endsWith', endsWith_1.default);
var empty = function (value) {
    return type_1.default(value) === 'Number'
        ? isNaN(value) || !isFinite(value)
        : type_1.default(value) === 'Boolean'
            ? false
            : isEmpty_1.default(value) || isNil_1.default(value);
};
exports.IS_EMPTY = ramdaFactory('IS_EMPTY', empty);
exports.isEmpty = ramdaFactory('isEmpty', empty);
exports.IN = ramdaFactory('IN', includes_1.default);
exports.includes = ramdaFactory('includes', includes_1.default);
var legacyStartsWith = function (a, b) { return startsWith_1.default(b, a); };
exports.STARTS_WITH = ramdaFactory('STARTS_WITH', legacyStartsWith);
exports.startsWith = ramdaFactory('startsWith', startsWith_1.default);
//# sourceMappingURL=legacy.js.map